import React from "react";
import { ReactComponent as Edit } from "../../../assets/icons/edit-fill.svg";
import { ReactComponent as Delete } from "../../../assets/icons/delete-fill.svg";

const ActionButtons = ({ onEdit, onDelete, userEmail = "", currentUserEmail = "" }) => {
  const normalizedUserEmail = String(userEmail).trim().toLowerCase();
  const normalizedCurrentUserEmail = String(currentUserEmail).trim().toLowerCase();
  const canDelete =
    !normalizedUserEmail || normalizedCurrentUserEmail !== normalizedUserEmail;

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onEdit}
        className="border border-primary rounded-full p-1"
        aria-label="Edit"
      >
        <Edit />
      </button>
      {canDelete && (
        <button
          onClick={onDelete}
          className="border border-warning rounded-full p-1"
          aria-label="Delete"
        >
          <Delete />
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
